import { makeAutoObservable } from 'mobx';
import { ICredentialsStore } from '../../integration-store';
import { ILabelGOCredentialsModel } from '../../../../../../models/IntegrationsTypes';

class LabelGOCredentialsStore implements ICredentialsStore {
    private _changes: ILabelGOCredentialsModel = {} as ILabelGOCredentialsModel;

    constructor() {
        makeAutoObservable(this, {}, { autoBind: true });
    }
    public get username() { return this._changes.username; };
    public get password() { return this._changes.password; };
    public get baseApiUrl() { return this._changes.base_api_url; };
    public get accountNumber() { return this._changes.account_number; };

    setUsername(value: string) {
        this._changes.username = value;
    };

    setPassword(value: string) {
        this._changes.password = value;
    };

    setBaseApiUrl(value: string) {
        this._changes.base_api_url = value;
    };

    setAccountNumber(value: string) {
        this._changes.account_number = value;
    };

    /** ICredentialsStore implementation ************/
    public async getCredentials() {
        return { ...this._changes };
    }
}

export default LabelGOCredentialsStore;
